import { AutomationActionIdentifier, AutomationTriggerIdentifier } from 'api/automation-builder/types';
export var AutomationType = /*#__PURE__*/ function(AutomationType) {
    AutomationType["Crm"] = "CRM";
    AutomationType["KeyEvents"] = "KEY_EVENTS";
    AutomationType["CustomAutomation"] = "CUSTOM_AUTOMATION";
    return AutomationType;
}({});
export var AutomationTriggerInterpretation = /*#__PURE__*/ function(AutomationTriggerInterpretation) {
    AutomationTriggerInterpretation["EachFieldChangedAndMatching"] = "EACH_FIELD_CHANGED_AND_MATCHING";
    AutomationTriggerInterpretation["AnyFieldChangedAndAllMatching"] = "ANY_FIELD_CHANGED_AND_ALL_MATCHING";
    return AutomationTriggerInterpretation;
}({});
export var AutomationObjectType = /*#__PURE__*/ function(AutomationObjectType) {
    AutomationObjectType["Task"] = "TASK";
    AutomationObjectType["Project"] = "PROJECT";
    AutomationObjectType["Phase"] = "PHASE";
    AutomationObjectType["Form"] = "FORM";
    AutomationObjectType["Invoice"] = "INVOICE";
    AutomationObjectType["Expense"] = "EXPENSE";
    AutomationObjectType["Company"] = "COMPANY";
    AutomationObjectType["Sheet"] = "SHEET";
    AutomationObjectType["SheetTab"] = "SHEET_TAB";
    AutomationObjectType["Note"] = "NOTE";
    AutomationObjectType["CompanyNote"] = "COMPANY_NOTE";
    AutomationObjectType["None"] = "NONE";
    return AutomationObjectType;
}({});
export var AutomationTriggerType = /*#__PURE__*/ function(AutomationTriggerType) {
    AutomationTriggerType["ScheduledTrigger"] = "SCHEDULED_TRIGGER";
    AutomationTriggerType["EventTrigger"] = "EVENT_TRIGGER";
    AutomationTriggerType["ExternalEventTrigger"] = "EXTERNAL_EVENT_TRIGGER";
    AutomationTriggerType["DateTrigger"] = "DATE_TRIGGER";
    AutomationTriggerType["ManualTrigger"] = "MANUAL_TRIGGER";
    return AutomationTriggerType;
}({});
export const TASK_TRIGGERS = [
    AutomationTriggerIdentifier.TaskCreatedV2,
    AutomationTriggerIdentifier.TaskDeleted,
    AutomationTriggerIdentifier.TaskDueDateIsUpdated,
    AutomationTriggerIdentifier.TaskStatusIsUpdatedV2,
    AutomationTriggerIdentifier.TaskAnyFieldIsUpdatedV2,
    AutomationTriggerIdentifier.TaskApprovalStatusIsUpdated,
    AutomationTriggerIdentifier.TaskApprovalRequest,
    AutomationTriggerIdentifier.TaskCSATSubmitted,
    AutomationTriggerIdentifier.NewMessageInTask,
    AutomationTriggerIdentifier.TaskBecomesOverdue,
    AutomationTriggerIdentifier.TaskRemainsInCertainStatus,
    AutomationTriggerIdentifier.TaskAssigneeIsUpdated,
    AutomationTriggerIdentifier.AnyTaskDueDateOverdue,
    AutomationTriggerIdentifier.TaskSpotlighted,
    AutomationTriggerIdentifier.TaskProjectFinancialsBudgetsUpdated
];
export const PHASE_TRIGGERS = [
    AutomationTriggerIdentifier.PhaseCreatedV2,
    AutomationTriggerIdentifier.PhaseStartDateIsChangedV2,
    AutomationTriggerIdentifier.PhaseDueDateIsChangedV2,
    AutomationTriggerIdentifier.PhaseStatusIsChangedV2,
    AutomationTriggerIdentifier.PhaseNameIsChangedV2,
    AutomationTriggerIdentifier.PhaseDeleted,
    AutomationTriggerIdentifier.PhaseProjectFinancialsBudgetsUpdated
];
export const PROJECT_TRIGGERS = [
    AutomationTriggerIdentifier.ProjectCreated,
    AutomationTriggerIdentifier.ProjectAnyFieldIsUpdated,
    AutomationTriggerIdentifier.ProjectFinancialFieldIsUpdated,
    AutomationTriggerIdentifier.ProjectArchived,
    AutomationTriggerIdentifier.ProjectDeleted,
    AutomationTriggerIdentifier.CustomerInvitedToProject,
    AutomationTriggerIdentifier.TeamMemberInvitedToProject,
    AutomationTriggerIdentifier.ProjectPlaceholderResolved,
    AutomationTriggerIdentifier.ProjectCustomerPortalChanged,
    AutomationTriggerIdentifier.ProjectNoteCreated,
    AutomationTriggerIdentifier.ProjectNoteUpdated,
    AutomationTriggerIdentifier.ProjectNoteDeleted
];
export const COMPANY_TRIGGERS = [
    AutomationTriggerIdentifier.CompanyCreated,
    AutomationTriggerIdentifier.CompanyAnyFieldIsUpdated,
    AutomationTriggerIdentifier.CompanyDeleted,
    AutomationTriggerIdentifier.CompanyNoteCreated,
    AutomationTriggerIdentifier.CompanyNoteUpdated,
    AutomationTriggerIdentifier.CompanyNoteDeleted
];
export const TASK_ACTIONS = [
    AutomationActionIdentifier.CreateTaskMessage,
    AutomationActionIdentifier.CreateTask,
    AutomationActionIdentifier.CreateSubTask,
    AutomationActionIdentifier.UpdateTaskAssignee,
    AutomationActionIdentifier.UpdateTaskStartDate,
    AutomationActionIdentifier.UpdateTaskDueDate,
    AutomationActionIdentifier.ShiftTaskDates,
    AutomationActionIdentifier.UpdateTaskStatus,
    AutomationActionIdentifier.UpdateTaskPhase,
    AutomationActionIdentifier.UpdateTaskField,
    AutomationActionIdentifier.RequestTaskApproval,
    AutomationActionIdentifier.SpotlightTask,
    AutomationActionIdentifier.DeleteTask,
    AutomationActionIdentifier.FollowTask
];
export const PHASE_ACTIONS = [
    AutomationActionIdentifier.UpdatePhaseStartDate,
    AutomationActionIdentifier.UpdatePhaseDueDate,
    AutomationActionIdentifier.UpdatePhaseStatus,
    AutomationActionIdentifier.UpdatePhaseName,
    AutomationActionIdentifier.DeletePhase
];
export const PROJECT_ACTIONS = [
    AutomationActionIdentifier.ImportTemplate,
    AutomationActionIdentifier.UpdateProjectFields,
    AutomationActionIdentifier.UpdateProjectNoteField,
    AutomationActionIdentifier.CreateProjectNoteField,
    AutomationActionIdentifier.UpdateProjectFinancialFields,
    AutomationActionIdentifier.CreateDocument,
    AutomationActionIdentifier.SendProjectUpdates,
    AutomationActionIdentifier.CreateProjectMessage,
    AutomationActionIdentifier.UpdateResourceAllocation,
    AutomationActionIdentifier.DeleteAllocations,
    AutomationActionIdentifier.ShiftAllocations,
    AutomationActionIdentifier.UpdateProjectStatus,
    AutomationActionIdentifier.ChangeCustomerPortalForProject,
    AutomationActionIdentifier.ArchiveProject,
    AutomationActionIdentifier.DeleteProject,
    AutomationActionIdentifier.ShiftProjectDates
];
export const GLOBAL_SIGNAL_TRIGGERS = [
    AutomationTriggerIdentifier.SignalOccurrenceCreated
];
export const RESOURCE_REQUEST_ACTIONS = [
    AutomationActionIdentifier.AssignResourceRequestApprover
];
export const COMPANY_ACTIONS = [
    AutomationActionIdentifier.UpdateCompanyFields,
    AutomationActionIdentifier.UpdateAccountNoteField,
    AutomationActionIdentifier.CreateAccountNoteField
];
export const GLOBAL_SIGNAL_GROUPED_ACTIONS = [
    ...COMPANY_ACTIONS
];
export const GLOBAL_SIGNAL_BUILDER_ACTIONS = [
    AutomationActionIdentifier.UpdateCompanyFields,
    AutomationActionIdentifier.UpdateAccountNoteField,
    AutomationActionIdentifier.CreateAccountNoteField,
    AutomationActionIdentifier.NotifySomeone,
    AutomationActionIdentifier.SendEmail,
    AutomationActionIdentifier.PushSignalWebHook,
    AutomationActionIdentifier.ExitAutomation
];
export const FORM_TRIGGERS = [
    AutomationTriggerIdentifier.FormDueDateIsUpdated,
    AutomationTriggerIdentifier.FormStatusIsUpdated,
    AutomationTriggerIdentifier.FormAssigneeIsUpdated,
    AutomationTriggerIdentifier.FormAnyFieldIsUpdated,
    AutomationTriggerIdentifier.NewMessageInForm,
    AutomationTriggerIdentifier.FormResponseSubmitted,
    AutomationTriggerIdentifier.FormCreated,
    AutomationTriggerIdentifier.FormApprovalStatusIsUpdated,
    AutomationTriggerIdentifier.FormApprovalRequest,
    AutomationTriggerIdentifier.FormCSATSubmitted,
    AutomationTriggerIdentifier.FormSpotlighted,
    AutomationTriggerIdentifier.FormDeleted
];
export const RESOURCE_REQUEST_TRIGGERS = [
    AutomationTriggerIdentifier.ResourceRequestCreated,
    AutomationTriggerIdentifier.ResourceRequestStatusUpdated,
    AutomationTriggerIdentifier.ResourceRequestApproverUpdated
];
export const BUDGET_TRIGGERS = [
    AutomationTriggerIdentifier.BudgetCreated,
    AutomationTriggerIdentifier.BudgetFieldUpdated,
    AutomationTriggerIdentifier.BudgetDeleted,
    AutomationTriggerIdentifier.PhaseProjectFinancialsBudgetsUpdated,
    AutomationTriggerIdentifier.TaskProjectFinancialsBudgetsUpdated
];
export const BUDGET_ACTIONS = [
    AutomationActionIdentifier.CreateBudget,
    AutomationActionIdentifier.UpdateBudgetField
];
export const INVOICE_TRIGGERS = [
    AutomationTriggerIdentifier.InvoiceMovesFromDraftToInReview
];
export const INVOICE_ACTIONS = [
    AutomationActionIdentifier.AssignApprovalToInvoice
];
export const SHEET_LEVEL_TRIGGERS = [
    AutomationTriggerIdentifier.SheetCreated,
    AutomationTriggerIdentifier.SheetDeleted,
    AutomationTriggerIdentifier.SheetAssigneeUpdated,
    AutomationTriggerIdentifier.SheetDueDateUpdated,
    AutomationTriggerIdentifier.SheetStatusUpdated,
    AutomationTriggerIdentifier.SheetFieldUpdated,
    AutomationTriggerIdentifier.SheetApprovalResponseReceived,
    AutomationTriggerIdentifier.NewMessageInSheet,
    AutomationTriggerIdentifier.SheetBecomesOverdue
];
export const SHEET_TAB_TRIGGERS = [
    AutomationTriggerIdentifier.RowMatchesCondition,
    AutomationTriggerIdentifier.RowAdded,
    AutomationTriggerIdentifier.RowUpdated,
    AutomationTriggerIdentifier.RowDeleted,
    AutomationTriggerIdentifier.SheetTabCreated,
    AutomationTriggerIdentifier.SheetTabDeleted,
    AutomationTriggerIdentifier.SheetTabStatusUpdated,
    AutomationTriggerIdentifier.SheetTabAssigneeUpdated,
    AutomationTriggerIdentifier.SheetTabBecomesOverdue
];
export const SHEET_MANUAL_TRIGGERS = [
    AutomationTriggerIdentifier.SheetManualTrigger
];
export const SHEET_ACTIONS = [
    AutomationActionIdentifier.CreateSheetTab,
    AutomationActionIdentifier.UpdateSheetAssignee,
    AutomationActionIdentifier.UpdateSheetStartDate,
    AutomationActionIdentifier.UpdateSheetDueDate,
    AutomationActionIdentifier.ShiftSheetDates,
    AutomationActionIdentifier.UpdateSheetStatus,
    AutomationActionIdentifier.UpdateSheetField,
    AutomationActionIdentifier.FreezeSheet,
    AutomationActionIdentifier.RequestSheetApproval,
    AutomationActionIdentifier.FollowSheet,
    AutomationActionIdentifier.DeleteSheet,
    AutomationActionIdentifier.CreateSheetMessage
];
export const SHEET_TAB_ACTIONS = [
    AutomationActionIdentifier.AddRow,
    AutomationActionIdentifier.UpdateRow,
    AutomationActionIdentifier.DeleteRow,
    AutomationActionIdentifier.UpdateSheetTabAssignee,
    AutomationActionIdentifier.UpdateSheetTabDueDate,
    AutomationActionIdentifier.FreezeSheetTab,
    AutomationActionIdentifier.RequestSheetTabApproval,
    AutomationActionIdentifier.DeleteSheetTab
];
export const SHEET_ACTIONS_ORDER = SHEET_ACTIONS;
export const SHEET_TAB_ACTIONS_ORDER = SHEET_TAB_ACTIONS;
export const EXPENSE_TRIGGERS = [
    AutomationTriggerIdentifier.ExpenseMovedFromDraftToSubmitted
];
export const EXPENSE_ACTIONS = [
    AutomationActionIdentifier.AutoApproveExpense,
    AutomationActionIdentifier.AssignApprovalToExpense
];
